import React, { useState, useEffect } from "react";
import axios from "axios";
import api from "../../config.json";
import swal from "sweetalert";

import { useLocation } from "react-router-dom";

const TimesettingForm = ({ history, Heading }) => {
  const [ruleData, setRuleData] = useState({
    RuleName: "", Default: "",
    Rules: [{ StartTime: "", EndTime: "", Tag: "", Midnight: false }],
  });
  const [DefaultRule, setDefaultRule] = useState({
    StartTime: "",
    EndTime: "",
    Tag: "Default",
  });
  const [error, setError] = useState("");
  const location = useLocation();

  useEffect(() => {
    if (location.state && location.state.action == "update") {
      console.log("Updating", location);
      setRuleData(location.state.data);
    }
  }, [location]);
  useEffect(() => {
    Heading("Rule Master");
  }, []);

  // Function to handle adding a new rule
  const addNewRule = () => {
    if (!validateRules()) return;
    setRuleData({
      ...ruleData,
      Rules: [...ruleData.Rules, { StartTime: "", EndTime: "", Tag: "", Midnight: false }],
    });
    setError("");
  };

  // Function to remove a rule
  const removeRule = (index) => {
    const newRules = ruleData.Rules.filter((_, i) => i !== index);
    setRuleData({ ...ruleData, Rules: newRules });
  };
  function validateTimeArray(timeArray) {
    // Loop through each object in the array
    for (let i = 0; i < timeArray.length; i++) {
      const current = timeArray[i];
      const isMidnight = current.Midnight;

      // Check if Tag is present and not empty
      if (!current.Tag || current.Tag.trim() === "") {
        setError(`Error: Tag field is required for row ${i + 1}`);
        return false;
      }
      // Check Midnight condition
      if (isMidnight) {
        // If Midnight is true, StartTime should be greater than EndTime (crossing date)
        if (current.StartTime <= current.EndTime) {
          setError(`Error: Midnight row should have StartTime greater than EndTime to indicate cross-date time at row ${i + 1}`);
          return false;
        }

        // Ensure Midnight object times are greater than the EndTime of the second last object
        if (i >= 1) {
          const secondLastEndTime = timeArray[timeArray.length - 2].EndTime;
          if (current.StartTime <= secondLastEndTime) {
            setError(`Error: Midnight row should have StartTime and EndTime greater than the second last row's EndTime`);
            return false;
          }
        }
      } else {
        // For non-Midnight objects, StartTime should be less than EndTime
        if (current.StartTime >= current.EndTime) {
          setError(`Error: StartTime should be less than EndTime in non-Midnight row at  ${i + 1}`);
          return false;
        }
      }

      // Check for overlapping time ranges with other objects
      for (let j = 0; j < timeArray.length; j++) {
        if (i !== j) { // Ensure we don't compare the object with itself
          const other = timeArray[j];
          const overlap =
            (!isMidnight && !other.Midnight && current.StartTime < other.EndTime && current.EndTime > other.StartTime) ||
            (isMidnight && other.Midnight && (current.StartTime < other.EndTime || current.EndTime > other.StartTime));

          if (overlap) {
            setError(`Error: Time range of row at  ${i + 1} overlaps with time range of row at  ${j + 1}`);
            return false;
          }
        }
      }
    }
    return true; // If all validations pass
  }

  // Function to validate Rules
  const validateRules = () => {
    if (!ruleData.RuleName) {
      setError("Rule Name is required.");
      return false;
    }

    if (!ruleData.Default) {
      setError("Default is required.");
      return false;
    }


    if (ruleData.Rules.length == 0) {
      setError("Min one rule of Start Of Time and  End Of Time is mandatory.");
      return false;
    } else {
      if (validateTimeArray(ruleData.Rules)) {
        return true
      } else {
        //setError("Please correct the start of time should be less to end of time OR if start time or end cross the date then should be Midnight.");
        return false;
      }
    }
  };

  // // Function to handle form submission
  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   if (!validateRules()) return;
  //   console.log('Rule Data:', ruleData);
  //   setError('');
  //   // Add further submission logic here (e.g., sending data to an API)
  // };

  // Function to handle input change for individual Rules
  const handleRuleChange = (index, field, value) => {
    const newRules = [...ruleData.Rules];
    newRules[index][field] = value;
    setRuleData({ ...ruleData, Rules: newRules });
    setError(""); // Clear error when changing input
  };
  const handleDefaultRuleChange = (field, value) => {
    setDefaultRule({ ...DefaultRule, [field]: value });
    setError(""); // Clear error when changing input
  };

  // Function to handle input change for the Rule Name
  const handleRuleNameChange = (e) => {
    const obj = { ...ruleData };
    obj[e.target.name] = e.target.value;
    setRuleData(obj);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateRules())
      return


    setError("")

    try {
      if (location.state && location.state.action === "update") {
        // Update existing record
        await axios.patch(`${api.api}RuleMaster/${ruleData._id}`, ruleData);
        swal("Update Successfully");
        history.push("/setting/rulemaster/list");
      } else {
        const response = await axios.post(`${api.api}RuleMaster`, ruleData);
        console.log("API Response:", response.data);
        history.push("/setting/rulemaster/list");
      }
      setError(""); // Clear any previous errors
    } catch (err) {
      // Handle errors
      if (err.response && err.response.data) {
        swal(`${err.response.data.message}`, { dangerMode: true });
      } else {
        swal("An error occurred. Please try again.");
      }
      setError("Failed to submit data. Please try again.");
    } finally {
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col" style={{ marginBottom: "15px" }}>
            <label>
              <strong>Rule Name:</strong>
            </label>
            <input
              name="RuleName"
              type="text"
              value={ruleData.RuleName}
              onChange={handleRuleNameChange}
              placeholder="Enter Rule Name"
              style={{ marginLeft: "10px", padding: "5px", width: "300px" }}
            />
          </div>
          <div className="col" style={{ marginBottom: "15px" }}>
            <label>
              <strong>Default:</strong>
            </label>
            <input
              name="Default"
              type="text"
              value={ruleData.Default}
              onChange={handleRuleNameChange}
              placeholder="Enter Default Value"
              style={{ marginLeft: "10px", padding: "5px", width: "300px" }}
            />
          </div>
        </div>


        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                Start of Time
              </th>
              <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                End of Time
              </th>
              <th className="text-center" style={{ border: "1px solid #ddd", padding: "8px" }}>
                Midnight
              </th>
              <th className="text-center" style={{ border: "1px solid #ddd", padding: "8px" }}>Tag</th>
              <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {ruleData.Rules.map((rule, index) => (
              <tr key={index}>
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                  {console.log(rule, "testing data")}
                  <input
                    className="form-control form-control-sm"
                    type="time"
                    value={rule.StartTime}
                    onChange={(e) =>
                      handleRuleChange(index, "StartTime", e.target.value)
                    }
                  />
                </td>
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                  <input
                    className="form-control form-control-sm"
                    type="time"
                    value={rule.EndTime}
                    onChange={(e) =>
                      handleRuleChange(index, "EndTime", e.target.value)
                    }
                  />
                </td>
                <td className="text-center" style={{ border: "1px solid #ddd", padding: "8px" }}>
                  <input
                    type="checkbox"
                    checked={rule.Midnight}
                    onChange={(e) =>
                      handleRuleChange(index, "Midnight", e.target.checked)
                    }
                  />
                </td>

                <td className="text-center" style={{ border: "1px solid #ddd", padding: "8px" }}>
                  <input
                    className="form-control form-control-sm"
                    type="text"
                    value={rule.Tag}
                    onChange={(e) =>
                      handleRuleChange(index, "Tag", e.target.value)
                    }
                    placeholder="Enter Tag"
                  />
                </td>
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                  <button
                    type="button"
                    className="btn-danger btn btn-sm"
                    onClick={() => removeRule(index)}
                  >
                    Remove Rule
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {error && <p style={{ color: "red" }}>{error}</p>}
        <button
          type="button"
          className="btn-primary btn btn-sm"
          onClick={addNewRule}
          style={{ margin: "10px 0" }}
        >
          Add New Rule
        </button>
        <br />
        <div className="text-center">
          <button type="submit" className="btn-primary btn btn-sm">
            Submit
          </button>
          <button onClick={() => history.push('/setting/rulemaster/list')} className="btn-primary ml-2 btn btn-sm">
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default TimesettingForm;
